<div class="app-layout">
  <main>
    <router-outlet />
  </main>
</div>
